import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconViewBoxesFillComponent } from "./med-icon-view-boxes-fill.component";

@NgModule({
  declarations: [
    MedIconViewBoxesFillComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconViewBoxesFillComponent,
  ],
})
export class MedIconViewBoxesFillModule { }
